import { styled } from '@mui/material'
import { Stack } from '@mui/system'

export const ActionBarStyles = styled(Stack)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
